import React from 'react'
import {config} from '../config'
const txdomain = config()['tourneyx-url']

//const Clubs = ({club_name, club_abbr, club_city, club_state}) => {

const Clubs = (club_array) => {
  //console.log('club_array value passed:::',club_array['club_information']);
  //club_array.length

  const club_information = club_array['club_information']
  //console.log('club_information length value passed:::',club_information.length);

  return (
    <>
    {   
        club_information.length > 0 ? 
        club_information.map(({club_name, club_abbr, club_city, club_state}, index) => 
         
        <div className="sidebar-widget" id="tourney-overview" key={index}>
          <h3>Clubs</h3>
          <h5>{club_name ? club_name : ''}</h5>
          <small>{club_city ? club_city : ''}, {club_state ? club_state : ''}</small>
          <br/>
          <a className='club-link' href={`${txdomain}/app/club/${club_abbr}`} >{`${txdomain}/app/club/${club_abbr}`}</a>
        </div>
        )
        :null
     
    }
       
         
      
    </>
  )

  

  
}

export default Clubs